// 1 订单完成
// 2 暂停
// 4 下个月取消
export var PackageStatusDic;
(function (PackageStatusDic) {
    PackageStatusDic[PackageStatusDic["Subscribed"] = 0] = "Subscribed";
    PackageStatusDic[PackageStatusDic["Unsubscribed"] = 2] = "Unsubscribed";
})(PackageStatusDic || (PackageStatusDic = {}));
// 实现支付类型对象
export const PackageStatusType = {
    ENUM: {
        [PackageStatusDic.Subscribed]: '已订购',
        [PackageStatusDic.Unsubscribed]: '未订购'
    },
    Subscribed: PackageStatusDic.Subscribed,
    Unsubscribed: PackageStatusDic.Unsubscribed
};
